import React from "react";
/* img imports */
import giantWheelStandBack from "../assets/images/giant-wheel/giant-wheel-base-back.png";
import giantWheelStandFront from "../assets/images/giant-wheel/giant-wheel-base-front.png";

const GiantWheelStands = () => {
  return (
    <>
      <div className="giant-wheel-stand-back">
        <img src={giantWheelStandBack} alt="" />
      </div>
      <div className="giant-wheel-stand-front">
        <img src={giantWheelStandFront} alt="" />
      </div>
    </>
  );
};

export default GiantWheelStands;
